module.exports = __webpack_public_path__ + "img/BM.4e868f65.png";